import { render, staticRenderFns } from "./ValidationAttendanceRemote.vue?vue&type=template&id=cf220a1a"
import script from "./ValidationAttendanceRemote.vue?vue&type=script&lang=js"
export * from "./ValidationAttendanceRemote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports